import { render } from "./Facturation.vue?vue&type=template&id=8784f106&scoped=true"
import script from "./Facturation.vue?vue&type=script&lang=js"
export * from "./Facturation.vue?vue&type=script&lang=js"

import "./Facturation.vue?vue&type=style&index=0&id=8784f106&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8784f106"]])

export default __exports__